import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export const CATEGORY_META = {
  bar:           { label: 'Bars',          emoji: '\u{1F378}', icon: 'martini', color: 'amber' },
  club:          { label: 'Clubs',         emoji: '\u{1F4AB}', icon: 'disc-3',  color: 'cyan' },
  lounge:        { label: 'Lounges',       emoji: '\u{1F379}', icon: 'wine',    color: 'amber' },
  coffee_shop:   { label: 'Coffee Shops',  emoji: '\u{2615}',  icon: 'coffee',  color: 'amber' },
  wine_vineyard: { label: 'Wine Vineyards',emoji: '\u{1F347}', icon: 'grape',   color: 'amber' },
  brewery:       { label: 'Breweries',     emoji: '\u{1F37A}', icon: 'beer',    color: 'amber' },
  frat_party:    { label: 'Frat Parties',  emoji: '\u{1F389}', icon: 'party-popper', color: 'amber' },
  cigar_bar:     { label: 'Cigar Bars',    emoji: '\u{1F6AC}', icon: 'cigarette', color: 'amber' },
  liquor_store:  { label: 'Liquor Stores', emoji: '\u{1F943}', icon: 'store',   color: 'amber' },
};

export const CATEGORY_ORDER = [
  'bar',
  'club',
  'lounge',
  'coffee_shop',
  'wine_vineyard',
  'brewery',
  'frat_party',
  'cigar_bar',
  'liquor_store',
];

export function categoryLabel(slug) {
  return CATEGORY_META[slug]?.label || slug;
}

export function timeAgo(iso) {
  if (!iso) return '';
  try {
    const d = typeof iso === 'string' ? new Date(iso) : iso;
    const diff = Math.floor((Date.now() - d.getTime()) / 1000);
    if (diff < 60) return `${diff}s`;
    if (diff < 3600) return `${Math.floor(diff / 60)}m`;
    if (diff < 86400) return `${Math.floor(diff / 3600)}h`;
    if (diff < 604800) return `${Math.floor(diff / 86400)}d`;
    return d.toLocaleDateString();
  } catch {
    return '';
  }
}

export async function fileToDataUrl(file, maxDim = 1400, quality = 0.82) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      const img = new Image();
      img.onload = () => {
        let { width, height } = img;
        if (width > maxDim || height > maxDim) {
          if (width >= height) {
            height = Math.round((height * maxDim) / width);
            width = maxDim;
          } else {
            width = Math.round((width * maxDim) / height);
            height = maxDim;
          }
        }
        const canvas = document.createElement('canvas');
        canvas.width = width;
        canvas.height = height;
        const ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0, width, height);
        resolve(canvas.toDataURL('image/jpeg', quality));
      };
      img.onerror = reject;
      img.src = e.target.result;
    };
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
}

export function getGeolocation() {
  return new Promise((resolve) => {
    if (!navigator.geolocation) return resolve(null);
    navigator.geolocation.getCurrentPosition(
      (pos) => resolve({ lat: pos.coords.latitude, lon: pos.coords.longitude }),
      () => resolve(null),
      { enableHighAccuracy: false, maximumAge: 5 * 60 * 1000, timeout: 7000 }
    );
  });
}
